import { useMe } from "lib/hooks/useMe"

import type {
  Environment,
  RootArgs,
} from "../__generated__/hypertune/hypertune"
import { HypertuneProvider } from "../__generated__/hypertune/hypertune.react"

export default function AppHypertuneProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const me = useMe()
  const adminUser: RootArgs["context"]["adminUser"] = me.data?.meAdmin
    ? { id: me.data.meAdmin.id, email: me.data.meAdmin.email }
    : { id: "", email: "" }

  // In admin app, we don't have webUser but we need to pass an empty object as required by hypertune schema
  const webUser: RootArgs["context"]["webUser"] = { id: "", email: "" }

  const rdeIDValue = process.env.NEXT_PUBLIC_RDE_ID || "";

  return (
    <HypertuneProvider
      createSourceOptions={{
        token: process.env.NEXT_PUBLIC_HYPERTUNE_TOKEN!,
        branchName: process.env.NEXT_PUBLIC_HYPERTUNE_BRANCH_NAME,
        initDataRefreshIntervalMs: 60_000,
      }}
      rootArgs={{
        context: {
          environment: process.env.NEXT_PUBLIC_APP_ENV as Environment,
          webUser,
          adminUser,
          rdeID: rdeIDValue,
        },
      }}
    >
      {children}
    </HypertuneProvider>
  )
}
